import { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import { SampleRequestService } from "../../../Services/SampleRequest.Service";
import SchedulePickupSampleRequestModal from "./SchedulePickupSampleRequestModal";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import * as Yup from "yup";
const SchedulePickupPage = ({ values, totalDuration, setTotalDuration, onBack, formikRef , toggleCollapseBox, boxRefs, errors, handlConfirmDelivery, setValidationSchema, validateForm, handleScrollUpOnSubmit, setSubmit,  scheduleSuccessData}) => {
    // const [values, setInitialValues] = useState({});
    // const [totalDuration, setTotalDuration] = useState(0);
    const [sampleTypes, setSampleTypes] = useState(0);

    const location = useLocation();

    const navigate = useNavigate();
    const EXTRA_DONOR_MULTIPLY_BY = 2;
    const DURATION_PER_DONOR = 10; //mins
    const [sampleBckpCount, setSampleBckpCount] = useState();

    useEffect(() => {
        if (setValidationSchema) {
            setValidationSchema(prev =>
                prev.shape({
                    scheduled_pickup: Yup.object()
                    .required('Please Schedule Sample Collection Pickup Date & Time') 
                    .nullable(),
                })
            );
        }
    }, []);


    useEffect(() => {
        // if (location.state) {debugger
        if (values) {
            // console.log(location.state);
            // setInitialValues(location.state.values);
            // setTotalDuration(location.state.totalDuration);


            // console.log(location.state.values.volunteers);

            // const sample_types = (location.state.values?.sample_types !== null &&  location.state.values?.sample_types !== undefined)
            // ? Object.keys(location.state.values.sample_types).length
            // : 0;

            // const sample_types = (values?.sample_types !== null && values?.sample_types !== undefined)
            //     ? Object.keys(values.sample_types).length
            //     : 0;

            // setSampleTypes(sample_types)


            const sampleTypeCount = values.sample_types
            ? Object.keys(values.sample_types).length
            : 0;
    
            setSampleTypes(sampleTypeCount);
        
            let backupCount = 0;
        
            if (values.matched_sample === 'Yes') {
        
                //  Matched + No special donor
                if (values.is_special_donor === 'No') {
                    backupCount = values.volunteers * EXTRA_DONOR_MULTIPLY_BY;
                }
        
                //  Matched + Special donor Yes
                else if (values.is_special_donor === 'Yes') {
        
                    const specialDonorCount =
                        values.special_donors?.length || 0;
        
                    const demographicCount =
                        values.special_donor_donorDemographicsData?.reduce(
                            (sum, ddm) => sum + (ddm.quantity || 0),
                            0
                        ) || 0;
        
                    backupCount =
                        specialDonorCount +
                        (demographicCount * EXTRA_DONOR_MULTIPLY_BY);
                }
            }
        
            //  Unmatched samples logic (future-safe)
            else {
                let totalBackup = 0;
            
                // get selected sample type ids like ["1","2"]
                const sampleTypeIds = values.sample_types
                    ? Object.keys(values.sample_types)
                    : [];
            
                sampleTypeIds.forEach((sampleTypeId) => {
                    // flag for this sample type: could be 'Yes'/'No' or boolean
                    const isSpecialFlag = values[`is_special_donor_${sampleTypeId}`];
            
                    const isSpecial = 
                        isSpecialFlag === 'Yes' ||
                        isSpecialFlag === true ||
                        isSpecialFlag === 'yes' ||
                        isSpecialFlag === 'true';
            
                    if (!isSpecial) {
                        // No special donor for this sample type → use volunteers * multiplier
                        totalBackup += (values.volunteers || 0) * EXTRA_DONOR_MULTIPLY_BY;
                    } else {
                        // Special donor(s) provided for this sample type
                        const specialDonors = values[`special_donors_${sampleTypeId}`] || [];
                        const demographics = values[`special_donor_donorDemographicsData_${sampleTypeId}`] || [];
            
                        const specialDonorCount = specialDonors.length || 0;
                        const demographicQty = demographics.reduce(
                            (sum, d) => sum + (d.quantity || 0),
                            0
                        );
            
                        totalBackup += specialDonorCount + (demographicQty * EXTRA_DONOR_MULTIPLY_BY);
                    }
                });
            
                backupCount = totalBackup;
            }
        
            setSampleBckpCount(backupCount);
            setTotalDuration(backupCount * DURATION_PER_DONOR);
        }
    }, [values, totalDuration]);

    // const sample_types = (values?.sample_types !== null &&  values?.sample_types !== undefined)
    // ? Object.keys(values.sample_types).length
    // : 0;

    // console.log("schedule pickup page", sample_types);
 

    // const [showTrainingModal, setShowTrainingModal] = useState(false);
    const [showTrainingModal, setShowTrainingModal] = useState(true);
    const handleClosePickupModal = () => setShowTrainingModal(false);
    const [scheduleType, setScheduleType] = useState("preferable");
 
    const confirmPickupModal = async (values) => {
    await formikRef.current.setFieldValue("scheduled_pickup", values);
        // Revalidate only this field
    await formikRef.current.validateField("scheduled_pickup");

    //     const submit = {
    //         values : formikRef.current.values,
    //         draft : false
    //     }
    // setSubmit(submit);
        // handleClosePickupModal();
    };

    const handleCloseTrainingModal = () => {
        setShowTrainingModal(false);
    }

    const [pickupDaysAvailableWRTSampleCount, setPickupDaysAvailableWRTSampleCount] = useState([]); // Initialize as an empty array
    const fetchSamplePickupWRTSampleCountList = async () => {
        try {

            if (sampleTypes != null && sampleTypes > 0) {

                const sample_countt = {
                    count: sampleTypes
                }
                SampleRequestService.getPickupListDetails(sample_countt)
                    .then(data => {
                        if (data.success) {
                            setPickupDaysAvailableWRTSampleCount(data.pickup);
                        }
                    })
                    .catch((err) => {
                        console.error("Error fetching sample type data:", err);
                        // setToastMessage(err.message);
                        // setToastVariant('error');
                        // setShowToast(true);
                        // setLoading(false);
                    });
            }
        }
        catch (error) { console.error("Error fetching sample pickup schedule with respect to sample count", error); }
    }


    useEffect(() => {
        fetchSamplePickupWRTSampleCountList();
    }, [values, sampleTypes]);

    const handleBackClick = () => {

          if (setValidationSchema) {
            setValidationSchema(prev =>
                prev.shape({
                    scheduled_pickup: Yup.object()
                    // .required('Please Schedule Sample Collection Pickup Date & Time') 
                    .nullable(),
                })
            );
        }
        if(scheduleSuccessData==null){
            onBack();
        }
        else{
            navigate('/requestor/requestor-sample-requests');
        }
        // navigate("/requestor/request-new-sample", {
        //     state: {
        //         values: values, 
        //         totalDuration: totalDuration
        //     }
        // });
    };

    // const handlConfirmDelivery =async () => {debugger
    //     const validationErrors = await formikRef.current.validateForm();

    //     if (Object.keys(validationErrors).length === 0) {
    //         formikRef.current.submitForm();   //  TRIGGERS PARENT SUBMIT
    //     } else {
    //         console.log("Errors:", validationErrors);
    //     }
    // };


    const confirmDelivery = async()=>{
        const validationErrors = await validateForm();  // checking here -> if no error then only do submit form with isDraft bool
        

        if (Object.keys(validationErrors).length === 0) {
            // handleSubmit(values, false); 
            handlConfirmDelivery()
        }
        else {
            handleScrollUpOnSubmit(validationErrors);
        } 
    }
    return (<>
        <div className="el-bg-table el-super-admin el-sr mb-4 mt-4 p-4 pb-1">
            <div className="el-bg-content-inner el-bg-content-inner-sr">
                <h3 className="el-title mt-1 mb-2">Schedule Sample Collection</h3>
                <button
                    onClick={(e) => toggleCollapseBox(sampleTypes > 0 ? sampleTypes + 700 : 700, e)}
                    className="el-bg-collapsable"
                    type="button"
                >
                    <i className="el-icon-up"></i>
                </button>
            </div>

            <div

                ref={(el) => (boxRefs.current[sampleTypes > 0 ? sampleTypes + 700 : 700] = el)}
                className="el-bg-collapsible-content el-bg-collapsible-content-sr open"
            // style={{ overflow: 'hidden', transition: 'height 0.3s ease', height: 'auto' }}
            >   
            {scheduleSuccessData ? (
                <>
                    {(scheduleSuccessData.success || !scheduleSuccessData.success) && (
                        <>
                            <div>
                                <p className="p-schedule-pickup">Success!</p>
                                <p className="p-schedule-pickup">Your job has been scheduled for delivery:</p>

                                {/* Scheduled Date & Time */}
                                <p className="p-schedule-pickup">
                                    {values?.scheduled_pickup && (() => {
                                        const { scheduledDate, selectedTime } = values.scheduled_pickup;

                                        // Format scheduled date
                                        const formattedScheduleDate = new Date(scheduledDate).toLocaleDateString(
                                            "en-US",
                                            {
                                                weekday: "long",
                                                year: "numeric",
                                                month: "long",
                                                day: "numeric",
                                            }
                                        );

                                        // Format scheduled time
                                        const [hour, minute] = selectedTime.split(":").map(Number);
                                        const ampm = hour >= 12 ? "PM" : "AM";
                                        const formattedHour = hour % 12 || 12;

                                        return (
                                            <span>
                                                {/* {formattedScheduleDate} by{" "}
                                                {`${formattedHour}:${minute.toString().padStart(2, "0")} ${ampm}`} */}
                                    {scheduleSuccessData.scheduled_date}

                                            </span>
                                        );
                                    })()}
                                </p>
                            </div>

                            {/* Cancellation Block */}
                            <div className="mt-3">
                                <p className="p-schedule-pickup">Cancelations:</p>
                                <p className="p-schedule-pickup">This job may be canceled with no charge before:</p>

                                {values?.scheduled_pickup && (() => {
                                    const { scheduledDate, selectedTime } = values.scheduled_pickup;

                                    // Convert to date
                                    const cancellationDate = new Date(scheduledDate);

                                    // Subtract 3 days
                                    cancellationDate.setDate(cancellationDate.getDate() - 3);

                                    // Format cancellation date
                                    const formattedCancelDate = cancellationDate.toLocaleDateString("en-US", {
                                        weekday: "long",
                                        year: "numeric",
                                        month: "long",
                                        day: "numeric",
                                    });

                                    // Same time as scheduled
                                    const [hour, minute] = selectedTime.split(":").map(Number);
                                    const ampm = hour >= 12 ? "PM" : "AM";
                                    const formattedHour = hour % 12 || 12;

                                    return (
                                        <p className="p-schedule-pickup">
                                                {/* {formattedCancelDate} at{" "}
                                                {`${formattedHour}:${minute.toString().padStart(2, "0")} ${ampm}`} */}
                                                {scheduleSuccessData.cancellation_date}
                                        </p>
                                    );
                                })()}
                            </div>

                            <p className="i-schedule-prickup mt-3">
                                <i>
                                    Your request may be canceled due to extreme weather conditions or power
                                    failures at the Quest Diagnostics patient service center.<br></br> We will make
                                    every effort to rebook asap. Delivery times may be impacted by traffic
                                    conditions.
                                </i>
                            </p>
                        </>
                    )}
                </>
            ) : (
                <>

                
            
            <div>
                <div className="schedule-sample-collection-head mb-2">
                    <h4>
                        NOTE:
                    </h4>
                    <h4 className="w-75">
                        Your job is NOT scheduled for delivery until you select a date, <br></br>
                        time and click Confirm Delivery Time.
                    </h4>
                </div>
                <p className="mt-4">Your request requires a <b>{totalDuration} min</b> appointment block.</p>
                {/* <p className="mt-4">Your request requires a <b>{sampleBckpCount * DURATION_PER_DONOR} min</b> appointment block.</p> */}
                <Row className="my-2">
                    <Col md={12}>
                        {/* <p>
                            Do you require your samples at a specific time of the day?{' '}
                            <span className="text-danger">*</span>
                        </p> */}

                        <h3 className="schedule-deli-title">Schedule Your Delivery</h3>
                    </Col>
                    <Col md={12} className="d-flex justify-content-start">
                        <Col className="my-3">
                        { sampleBckpCount > 0 && (
                              <SchedulePickupSampleRequestModal
                                show={showTrainingModal}
                                onConfirm={confirmPickupModal}
                                handleClose={handleCloseTrainingModal}
                                type={scheduleType}
                                duration={totalDuration}
                                // duration={sampleBckpCount * DURATION_PER_DONOR}
                                // sample_count={selectedSamples.length * voluenteers}
                                sample_ids= {values.sample_types || []}
                                sample_count={values.matched_sample == 'No' ? sampleTypes * values?.volunteers : values?.volunteers } // when unmatched then voluenteer * selectedSamples.length // when matched then voluenteer
                                volunteer_count={sampleBckpCount}  // 
                                lab_id={values?.lab_id}
                                div_type={"as-div"} //or as-accord
                                confirmDelivery = {confirmDelivery}
                            />
                        )}
                                {/* //data-error={errors['scheduled_pickup'] ? "true" : "false"} */}
                            {/* <div className="d-flex justify-content-start"  >
                                <button className="el-main-button me-0 p-2 px-4" onClick={(e) => handleSchedulePickupClick(e, "no-preferable")} >
                                    <span> No (preferable), Schedule Now</span>
                                </button>&nbsp;&nbsp;&nbsp;&nbsp;
                                <button className="el-main-button me-0 p-2 px-4 " onClick={(e) => handleSchedulePickupClick(e, "preferable")}  >
                                    <span> Yes, Schedule Now</span>
                                </button>
                            </div> */}

                            <div className="mt-1">
                                {values?.scheduled_pickup && (<p>Your scheduled pickup date:  {new Date(values?.scheduled_pickup.scheduledDate).toLocaleDateString("en-US", {
                                    weekday: "long", // Add the day name
                                    year: "numeric",
                                    month: "long",
                                    day: "numeric",
                                })} | {(() => {
                                    const [hour, minute] = values?.scheduled_pickup.selectedTime.split(':').map(Number);
                                    const ampm = hour >= 12 ? 'PM' : 'AM';
                                    const formattedHour = hour % 12 || 12; // Convert 0 hour to 12 for 12-hour format
                                    return `${formattedHour}:${minute.toString().padStart(2, '0')} ${ampm}`;
                                })()}</p>)}
                            </div>
                        {errors['scheduled_pickup'] && (
                        (<div className="text-danger mt-3">{errors[`scheduled_pickup`]}</div>)
                        )}
                        </Col>
                    </Col>
                </Row>
                <p>Samples available on or after:</p>
                <div className="my-2">
                    <div>
                        {pickupDaysAvailableWRTSampleCount.length > 0 ? (
                            <ul>
                                {pickupDaysAvailableWRTSampleCount.map((pickupDay) => (
                                    <li key={pickupDay.id}>
                                        {pickupDay.max_sample
                                            ? `${pickupDay.min_sample} to ${pickupDay.max_sample} samples | ${pickupDay.day} Business days`
                                            : `${pickupDay.min_sample}+ samples | ${pickupDay.day} Business days`}
                                    </li>
                                ))}
                            </ul>
                        ) : (
                            <p>Loading data...</p>
                        )}
                    </div>
                </div>
                <p>
                    * If you're able to select the first available appointment on a specific day, that will help
                    us maximize the number of collections we can do in a single day.
                </p>
            </div>
                </>
            )}
            </div>
        </div>
        <button
            className="el-main-button p-2 px-4"
            onClick={() => handleBackClick()}
        >
            <span>Back</span>
        </button>
      
    </>)
}
export default SchedulePickupPage;